import React from "react";

interface PolygonIconProps {
  size?: number | string;
  className?: string;
  rotate?: "up" | "down";
  color?: string;
  transition?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

const PolygonIcon: React.FC<PolygonIconProps> = ({

  className,
  rotate = "up",
  transition,
  onClick,
  disabled,
}) => {
  const getRotateDeg = (val: "up" | "down"): string => {
    switch (val) {
      case "up":
        return "0";

      default:
        return "180";
    }
  };
  return (
    <svg
      width="13"
      height="10"
      viewBox="0 0 7 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transition: transition ? "transform 0.2s ease-in-out" : "",
        transform: `rotate(${getRotateDeg(rotate)}deg)`,
      }}
      className={`${className} ${disabled ? "class-disable" : ""} `}
      onClick={onClick}
    >
      <path
        d="M3.60691 0.553711L6.86845 3.69212H0.345381L3.60691 0.553711Z"
        fill="#BABDC1"
      />
    </svg>
  );
};

export default PolygonIcon;
